const PAGES = {
    HOME: 'HOME',
    UNSUBSCRIBE: 'UNSUBSCRIBE',
    NOT_FOUND: 'NOT_FOUND',
};

export default PAGES;